<template>
  <v-app>
    <v-main :style="{ 'background-color': getBackgroundColor }">
      <v-col class="pa-0">
        <v-card :variant="'text'">
          <!-- <v-card :variant="'text'" :style="showHeader ? 'height: 94.5vh; overflow-y: auto' : ''"> -->
          <router-view v-if="!isLoading" />
          <div v-else>
            <v-col align="center" style="margin-top: 35vh" class="py-0">
              <v-progress-circular size="110" indeterminate color="primary"></v-progress-circular>
            </v-col>
          </div>
        </v-card>
      </v-col>
    </v-main>
  </v-app>
</template>

<script>
import engine from "@/core/index";

export default {
  // name: "",
  data() {
    return {
      selectedPage: undefined,
      isLoading: true,
    };
  },
  mounted() {
    this.updateUser();
    this.selectedPage = window.location.pathname.replace("/", "");
  },
  methods: {
    updateUser() {
      let that = this;
      let token = localStorage.getItem("userToken");
      let nbrDivision = this.$route.path.split("/").filter((val) => val.length > 0)
        .length;
      if (nbrDivision <= 1) {
        engine.get_user_by_token(token, function (data) {
          if (data.code == 0) {
            that.isLoading = false;
          } else {
            that.$router.push("/login");
            that.isLoading = false;
          }
        });
      } else {
        that.isLoading = false;
      }
    },
    logOut() {
      // localStorage.clear();
      localStorage.setItem("userToken", undefined);
      this.goTo("/login");
    },
    goTo(href) {
      this.$router.push(href);
    },
  },
  computed: {
    getBackgroundColor() {
      let url = this.$route.fullPath.replace("/", "");
      let color = "#90A4AE";
      let colorTab = {
        "": "#E0E0E0",
        login: "#E0E0E0",
        "planning-disponibilite": "#90A4AE",
        "planning-livraison": "#90A4AE",
        "planning-operateur": "#90A4AE",
        "planning-gestion-rdv-velo": "#90A4AE",
        "email-visualisation": "#90A4AE",
        "etat-des-lieux-materiel": "#90A4AE",
        statistiques: "#90A4AE",
        "gestion-livraison": "#90A4AE",
        "signature-en-ligne": "#90A4AE",
        "sav-gestion": "#90A4AE",
      };
      if (colorTab[url] != undefined) color = colorTab[url];
      return color;
    },
    getAppBarTitile() {
      return "ACCEN - Gestion congé";
    },
    getApp() {
      if (this.$route.fullPath == "/") return "";

      let path = this.$route.fullPath
        .replace("/", "")
        .replaceAll("-", " ")
        .split("?")[0]
        .toUpperCase();

      return path;
    },
    showHeader() {
      // let show = ["/", "/login"];

      let query = this.$route.query;

      if (query && query.header && query.header == "hide") return false;
      else return true;
      // return !show.includes(this.$route.fullPath);
    },
    isHomePage() {
      let show = ["/"];
      return show.includes(this.$route.fullPath);
    },
  },
};
</script>

<style>
@import "./style.css";
</style>
